import { useForm } from 'react-hook-form'
import {
    Select,
    FormErrorMessage, FormLabel, FormControl, Input,
    Button, Flex, useDisclosure, Box, useColorModeValue, Spacer,
    Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton,
} from '@chakra-ui/react'
import React, {useState} from "react";
import {useAuthHeader} from "react-auth-kit";
import axios from "axios";
import {useNavigate} from "react-router-dom";
import {DatePicker} from '@gsebdev/react-simple-datepicker';

export default function LimitCreate() {
    const textColor = useColorModeValue("gray.200", "white");
    const token = useAuthHeader();
    const [limitResponse, setLimitResponse] = useState('')
    const [showError, setShowError] = useState(null)
    const navigate = useNavigate();
    const {
        handleSubmit,
        register,
        setValue,
        formState: { errors, isSubmitting },
    } = useForm()
    const { isOpen, onOpen, onClose } = useDisclosure()

    const toggle = () => {
        onClose()
        navigate(`/admin_area/limits`);
    }

    const toggleShow = () => {
        setShowError(true)
    }

    const onchangeFrom = ({target}) => {
        let year = target.value.split("/")[2]
        let month = target.value.split("/")[0]
        let day = target.value.split("/")[1]
        setValue('active_from', year + '-' + month + '-' + day + "T00:00:00")
    }

    const onchangeTo = ({target}) => {
        let year = target.value.split("/")[2]
        let month = target.value.split("/")[0]
        let day = target.value.split("/")[1]
        setValue('active_to', year + '-' + month + '-' + day + "T00:00:00")
        setValue('reset_schedule', null)
    }

    const onchangeSchedule = () => {
        setValue('reset_schedule', null)
    }

    async function onSubmit(values) {
        try {
            const newData = await createLimit(values, token());
            setLimitResponse(newData)
            onOpen()
        } catch (e) {
            return new Promise((resolve) => {
                setTimeout(() => {
                    alert(JSON.stringify(e.response.data, null, 2))
                    resolve()
                }, 1000)
            })
        }
    }

    return (
        <Flex direction='column' pt={{ base: "150px", md: "75px" }}>

            <Box w='100%' mb='20px'>
                <Flex maxW='500px'>
                <Button colorScheme='teal' type='submit' onClick={() => {navigate(`/admin_area/limits`)}}>
                    Назад
                </Button>
                    <Spacer/>
                <Button colorScheme='teal' type='submit' onClick={() => {
                    setValue('active_from', "2023-09-14T00:00:00")
                    setValue('active_to', null)
                    setValue('error_description', "Default limit")
                    setValue('limit', 10000)
                    setValue('parent_card', "*")
                    setValue('parent_card_network', "NULL")
                    setValue('parent_emitent', "NULL")
                    setValue('parent_env', "NULL")
                    setValue('parent_profile', "NULL")
                    setValue('parent_provider', "NULL")
                    setValue('parent_terminal', "NULL")
                    setValue('parent_tx_type', "NULL")
                    setValue('reset_schedule', "daily_msk")
                    setValue('tags', [])
                    setValue('type', "inc")
                }}>
                    Выбрать шаблон
                </Button>
                </Flex>
            </Box>

            <Box
                border='1px'
                borderRadius='5px'
                borderColor={textColor}
                maxW='500px'
                w='100%'
                p={4}
            >

                <form onSubmit={handleSubmit(onSubmit)}>
                        <FormControl isInvalid={errors.active_from}>
                            <FormLabel htmlFor='active_from'>Время начала активности лимита</FormLabel>
                            <DatePicker
                                id='active_from'
                                onChange={onchangeFrom}
                                value={'01/02/2023'}
                            />
                            <FormErrorMessage>
                                {errors.active_from && errors.active_from.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.active_to}>
                            <FormLabel mt={"10px"} htmlFor='active_to'>Время завершения активности лимита</FormLabel>
                            <DatePicker
                                id='active_to'
                                onChange={onchangeTo}
                                value={'01/02/2023'}
                            />
                            <FormErrorMessage>
                                {errors.active_to && errors.active_to.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.type}>
                            <FormLabel mt={"10px"} htmlFor='type'>Тип ограничения</FormLabel>
                            <Select
                                id='type'
                                {...register('type', {
                                    required: 'This is required'
                                })}
                            >
                                <option value='inc'>inc</option>
                                <option value='sum'>sum</option>
                            </Select>

                            <FormErrorMessage>
                                {errors.type && errors.type.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.limit}>
                            <FormLabel mt={"10px"} htmlFor='limit'>Значение лимита</FormLabel>
                            <Input
                                id='limit'
                                type="number"
                                placeholder='0'
                                {...register('limit', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.limit && errors.limit.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.parent_card}>
                            <FormLabel mt={"10px"} htmlFor='parent_card'>Ограничение по карте</FormLabel>
                            <Input
                                id='parent_card'
                                placeholder='* or NULL'
                                {...register('parent_card', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_card && errors.parent_card.message}
                            </FormErrorMessage>
                        </FormControl>


                        <FormControl isInvalid={errors.parent_emitent}>
                            <FormLabel mt={"10px"} htmlFor='parent_emitent'>Ограничение по эмитенту</FormLabel>
                            <Input
                                id='parent_emitent'
                                placeholder='NULL or emitent/name'
                                {...register('parent_emitent', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_emitent && errors.parent_emitent.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.parent_profile}>
                            <FormLabel mt={"10px"} htmlFor='parent_profile'>Ограничение по профилю партнера</FormLabel>
                            <Input
                                id='parent_profile'
                                placeholder='NULL or profile/72'
                                {...register('parent_profile', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_profile && errors.parent_profile.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.parent_provider}>
                            <FormLabel mt={"10px"} htmlFor='parent_provider'>Ограничение по провайдеру</FormLabel>
                            <Input
                                id='parent_provider'
                                placeholder='NULL or provider/mtsbank'
                                {...register('parent_provider', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_provider && errors.parent_provider.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.parent_terminal}>
                            <FormLabel mt={"10px"} htmlFor='parent_terminal'>Ограничение по терминалу</FormLabel>
                            <Input
                                id='parent_terminal'
                                placeholder='NULL or terminal/:id'
                                {...register('parent_terminal', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_terminal && errors.parent_terminal.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.reset_schedule}>
                            <FormLabel mt={"10px"} htmlFor='reset_schedule'>Расписание работы лимита</FormLabel>
                            <Select
                                id='reset_schedule'
                                {...register('reset_schedule')}
                            >
                                <option value={onchangeSchedule}>null</option>
                                <option value='daily_msk'>daily_msk</option>
                                <option value='monthly_msk'>monthly_msk</option>
                            </Select>
                            <FormErrorMessage>
                                {errors.reset_schedule && errors.reset_schedule.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.parent_tx_type}>
                            <FormLabel mt={"10px"} htmlFor='parent_tx_type'>Ограничение по типу транзакции</FormLabel>
                            <Input
                                id='parent_tx_type'
                                placeholder='NULL or tx/type/payout or tx/type/payment'
                                {...register('parent_tx_type', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_tx_type && errors.parent_tx_type.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.parent_env}>
                            <FormLabel mt={"10px"} htmlFor='parent_env'>Ограничение по среде инициации транзакции</FormLabel>
                            <Input
                                id='parent_env'
                                placeholder='NULL or tx/env/prod'
                                {...register('parent_env', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_env && errors.parent_env.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.parent_card_network}>
                            <FormLabel mt={"10px"} htmlFor='parent_card_network'>Ограничение по типу МПС</FormLabel>
                            <Input
                                id='parent_card_network'
                                placeholder='NULL or card_network/JCB or card_network/NSPK MIR'
                                {...register('parent_card_network', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.parent_card_network && errors.parent_card_network.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.tags}>
                            <FormLabel mt={"10px"} htmlFor='tags'>Теги</FormLabel>
                            <Input
                                id='tags'
                                placeholder='{}'
                                {...register('tags', {

                                })}
                            />
                            <FormErrorMessage>
                                {errors.tags && errors.tags.message}
                            </FormErrorMessage>
                        </FormControl>

                        <FormControl isInvalid={errors.error_description}>
                            <FormLabel mt={"10px"} htmlFor='error_description'>Описание ошибки</FormLabel>
                            <Input
                                id='error_description'
                                placeholder='limit on the number of card transactions (5)'
                                {...register('error_description', {
                                    required: 'This is required',
                                })}
                            />
                            <FormErrorMessage>
                                {errors.error_description && errors.error_description.message}
                            </FormErrorMessage>
                        </FormControl>

                        <Button mt={4} colorScheme='teal' isLoading={isSubmitting} type='submit'>
                            Создать новый лимит
                        </Button>
                    </form>

            </Box>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Создание лимита</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {limitResponse.info
                            ? limitResponse.info
                            : <pre>{JSON.stringify(limitResponse, null, 2)}</pre>
                        }
                        <br/>
                        <br/>
                        {showError
                            ? <pre-wrap>{JSON.stringify(limitResponse.error, null, 2)}</pre-wrap>
                            : ''
                        }
                    </ModalBody>
                    <ModalFooter>
                        {limitResponse.error
                            ? <Button colorScheme='red' onClick={toggleShow}>Подробности</Button>
                            : ''
                        }
                        <Spacer/>
                        <Button colorScheme='blue' onClick={toggle}>Закрыть</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Flex>
    )
}


async function createLimit(params, token) {
    try {
        let raw = {
            active_from: params.active_from,
            active_to: params.active_to,
            error_description: params.error_description,
            limit: params.limit,
            parent_card: params.parent_card,
            parent_card_network: params.parent_card_network,
            parent_emitent: params.parent_emitent,
            parent_env: params.parent_env,
            parent_profile: params.parent_profile,
            parent_provider: params.parent_provider,
            parent_terminal: params.parent_terminal,
            parent_tx_type: params.parent_tx_type,
            reset_schedule: params.reset_schedule,
            tags: [],
            type: params.type
        };

        const response = await axios.post(`/api/v1/limits/templates`, raw,
            {headers: {Authorization: token}})
        return await response.data
    } catch (e) {
        if (e.response) {
            let error = {}
            error['info'] = "Невозможно создать, такой лимит уже существует"
            if ( Object.assign(e.response.data).errors ) {
                error['error'] = Object.assign(e.response.data).errors
            } else {
                error['error'] = e.response.data
            }

            return error
        }
    }
}
